// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/users.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/collapse.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/expand.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/add.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meetingPageAnalysis {
    background: #FFFFFF;
    border-radius: 8px;
    border: 0.5px solid rgba(0, 0, 0, 0.08);
    overflow: hidden;
    margin-bottom: 12px;
}

.meetingPageAnalysis_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s ease;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
}

.meetingPageAnalysis_header:hover {
    background-color: rgba(0, 0, 0, 0.02);
}

.meetingPageAnalysis_title_wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.meetingPageAnalysis_title {
    font-size: calc(15px * var(--fontScaler));
    font-weight: 500;
    color: #1D1D1F;
}

.meetingPageAnalysis_filter_icon {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 16px;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s ease;
}

.meetingPageAnalysis_filter_icon:hover {
    opacity: 1;
}

.meetingPageAnalysis_filter_icon--active {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    opacity: 0.7;
}

.meetingPageAnalysis_filter_icon--active:hover {
    opacity: 1;
}

.meetingPageAnalysis_toggle {
    display: flex;
    align-items: center;
    justify-content: center;
}

.meetingPageAnalysis_toggle_icon {
    width: 16px;
    height: 16px;
    position: relative;
}

.meetingPageAnalysis_toggle_icon::before,
.meetingPageAnalysis_toggle_icon::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    transition: opacity 0.2s ease;
    opacity: 0.6;
}

.meetingPageAnalysis_toggle_icon::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.meetingPageAnalysis_toggle_icon::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    opacity: 0;
}

.meetingPageAnalysis--collapsed .meetingPageAnalysis_toggle_icon::before {
    opacity: 0;
}

.meetingPageAnalysis--collapsed .meetingPageAnalysis_toggle_icon::after {
    opacity: 0.6;
}

.meetingPageAnalysis_drop {
    display: grid;
    grid-template-rows: 1fr;
    transition: grid-template-rows 200ms cubic-bezier(0.075, 0.82, 0.165, 1);
    overflow: hidden;
}

.meetingPageAnalysis--collapsed .meetingPageAnalysis_drop {
    grid-template-rows: 0fr;
}

.meetingPageAnalysis_drop_content {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
    position: relative;
}

.meetingPageAnalysis_overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.meetingPageAnalysis_spinner {
    width: 24px;
    height: 24px;
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-top-color: #F5A623;
    border-radius: 50%;
    animation: meetingPageAnalysis_spin 0.8s linear infinite;
}

@keyframes meetingPageAnalysis_spin {
    to {
        transform: rotate(360deg);
    }
}

.meetingPageAnalysis_actions {
    padding: 12px 0;
    border-top: 0.5px solid rgba(0, 0, 0, 0.06);
}

.meetingPageAnalysis_add_wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: opacity 0.2s ease;
    opacity: 0.7;
}

.meetingPageAnalysis_add_wrapper:hover {
    opacity: 1;
}

.meetingPageAnalysis_add_wrapper--disabled {
    pointer-events: none;
    opacity: 0.4;
}

.meetingPageAnalysis_add_icon {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    flex-shrink: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 11px;
    background-position: center;
    background-repeat: no-repeat;
}

.meetingPageAnalysis_add_text {
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    color: #1D1D1F;
}

.meetingPageAnalysis_loading {
    text-align: center;
    color: #86868B;
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    padding: 20px 16px;
}

.meetingPageAnalysis_empty {
    text-align: center;
    color: #86868B;
    font-size: calc(13px * var(--fontScaler));
    font-weight: 400;
    padding: 20px 16px;
}

.meetingPageAnalysis_empty_folder {
    text-align: center;
    color: #B8B8B8;
    font-size: calc(12px * var(--fontScaler));
    padding: 15px;
}

.meetingPageAnalysis_breadcrumbs {
    padding: 8px 16px;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);
}

.meetingPageAnalysis_content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    max-height: 300px;
    padding: 8px 16px;
}

.meetingPageAnalysis_folders {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding-top: 8px;
}

.meetingPageAnalysis_folder_item {
    transform: scale(0.95);
    transform-origin: left center;
}

/* Scrollbar - macOS style */
.meetingPageAnalysis_content::-webkit-scrollbar {
    width: 6px;
}

.meetingPageAnalysis_content::-webkit-scrollbar-track {
    background: transparent;
}

.meetingPageAnalysis_content::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 4px;
}

.meetingPageAnalysis_content::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.25);
}

/* File popup */
.meetingPageAnalysis_file_popup_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.meetingPageAnalysis_file_popup_content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 900px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.meetingPageAnalysis_file_popup_header {
    padding: 16px 20px;
    border-bottom: 1px solid #E2E9FC;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
}

.meetingPageAnalysis_file_popup_title {
    font-size: calc(16px * var(--fontScaler));
    font-weight: 600;
    color: #333;
}

.meetingPageAnalysis_file_popup_close {
    background: none;
    border: none;
    font-size: calc(20px * var(--fontScaler));
    color: #999;
    cursor: pointer;
    padding: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.2s;
}

.meetingPageAnalysis_file_popup_close:hover {
    background: #F5F5F5;
    color: #333;
}

.meetingPageAnalysis_file_popup_body {
    padding: 16px 20px;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
}

.meetingPageAnalysis_file_popup_body::-webkit-scrollbar {
    width: 6px;
}

.meetingPageAnalysis_file_popup_body::-webkit-scrollbar-track {
    background: #F5F5F5;
    border-radius: 4px;
}

.meetingPageAnalysis_file_popup_body::-webkit-scrollbar-thumb {
    background: #D5D9E2;
    border-radius: 4px;
}

.meetingPageAnalysis_file_popup_body::-webkit-scrollbar-thumb:hover {
    background: #B5B9C2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/components/meetingPageAnalysisWidget/MeetingPageAnalysisWidget.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;IACvC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,yDAAwD;AAC5D;;AAEA;IACI,yDAAsD;IACtD,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,wEAAwE;IACxE,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yDAAmD;IACnD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA,4BAA4B;AAC5B;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,eAAe;AACf;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;IACzC,WAAW;IACX,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".meetingPageAnalysis {\n    background: #FFFFFF;\n    border-radius: 8px;\n    border: 0.5px solid rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n    margin-bottom: 12px;\n}\n\n.meetingPageAnalysis_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    cursor: pointer;\n    user-select: none;\n    transition: background-color 0.2s ease;\n    border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);\n}\n\n.meetingPageAnalysis_header:hover {\n    background-color: rgba(0, 0, 0, 0.02);\n}\n\n.meetingPageAnalysis_title_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.meetingPageAnalysis_title {\n    font-size: calc(15px * var(--fontScaler));\n    font-weight: 500;\n    color: #1D1D1F;\n}\n\n.meetingPageAnalysis_filter_icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/user.svg');\n    background-size: 16px;\n    background-position: center;\n    background-repeat: no-repeat;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n}\n\n.meetingPageAnalysis_filter_icon:hover {\n    opacity: 1;\n}\n\n.meetingPageAnalysis_filter_icon--active {\n    background-image: url('../../../../assets/users.svg');\n    opacity: 0.7;\n}\n\n.meetingPageAnalysis_filter_icon--active:hover {\n    opacity: 1;\n}\n\n.meetingPageAnalysis_toggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.meetingPageAnalysis_toggle_icon {\n    width: 16px;\n    height: 16px;\n    position: relative;\n}\n\n.meetingPageAnalysis_toggle_icon::before,\n.meetingPageAnalysis_toggle_icon::after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    transition: opacity 0.2s ease;\n    opacity: 0.6;\n}\n\n.meetingPageAnalysis_toggle_icon::before {\n    background-image: url('../../../../assets/collapse.svg');\n}\n\n.meetingPageAnalysis_toggle_icon::after {\n    background-image: url('../../../../assets/expand.svg');\n    opacity: 0;\n}\n\n.meetingPageAnalysis--collapsed .meetingPageAnalysis_toggle_icon::before {\n    opacity: 0;\n}\n\n.meetingPageAnalysis--collapsed .meetingPageAnalysis_toggle_icon::after {\n    opacity: 0.6;\n}\n\n.meetingPageAnalysis_drop {\n    display: grid;\n    grid-template-rows: 1fr;\n    transition: grid-template-rows 200ms cubic-bezier(0.075, 0.82, 0.165, 1);\n    overflow: hidden;\n}\n\n.meetingPageAnalysis--collapsed .meetingPageAnalysis_drop {\n    grid-template-rows: 0fr;\n}\n\n.meetingPageAnalysis_drop_content {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n    position: relative;\n}\n\n.meetingPageAnalysis_overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.7);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n}\n\n.meetingPageAnalysis_spinner {\n    width: 24px;\n    height: 24px;\n    border: 2px solid rgba(0, 0, 0, 0.1);\n    border-top-color: #F5A623;\n    border-radius: 50%;\n    animation: meetingPageAnalysis_spin 0.8s linear infinite;\n}\n\n@keyframes meetingPageAnalysis_spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.meetingPageAnalysis_actions {\n    padding: 12px 0;\n    border-top: 0.5px solid rgba(0, 0, 0, 0.06);\n}\n\n.meetingPageAnalysis_add_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n    opacity: 0.7;\n}\n\n.meetingPageAnalysis_add_wrapper:hover {\n    opacity: 1;\n}\n\n.meetingPageAnalysis_add_wrapper--disabled {\n    pointer-events: none;\n    opacity: 0.4;\n}\n\n.meetingPageAnalysis_add_icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-image: url('../../../../assets/add.svg');\n    background-size: 11px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.meetingPageAnalysis_add_text {\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    color: #1D1D1F;\n}\n\n.meetingPageAnalysis_loading {\n    text-align: center;\n    color: #86868B;\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    padding: 20px 16px;\n}\n\n.meetingPageAnalysis_empty {\n    text-align: center;\n    color: #86868B;\n    font-size: calc(13px * var(--fontScaler));\n    font-weight: 400;\n    padding: 20px 16px;\n}\n\n.meetingPageAnalysis_empty_folder {\n    text-align: center;\n    color: #B8B8B8;\n    font-size: calc(12px * var(--fontScaler));\n    padding: 15px;\n}\n\n.meetingPageAnalysis_breadcrumbs {\n    padding: 8px 16px;\n    border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);\n}\n\n.meetingPageAnalysis_content {\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    max-height: 300px;\n    padding: 8px 16px;\n}\n\n.meetingPageAnalysis_folders {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding-top: 8px;\n}\n\n.meetingPageAnalysis_folder_item {\n    transform: scale(0.95);\n    transform-origin: left center;\n}\n\n/* Scrollbar - macOS style */\n.meetingPageAnalysis_content::-webkit-scrollbar {\n    width: 6px;\n}\n\n.meetingPageAnalysis_content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.meetingPageAnalysis_content::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.15);\n    border-radius: 4px;\n}\n\n.meetingPageAnalysis_content::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 0, 0, 0.25);\n}\n\n/* File popup */\n.meetingPageAnalysis_file_popup_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.meetingPageAnalysis_file_popup_content {\n    background: white;\n    border-radius: 12px;\n    width: 90%;\n    max-width: 900px;\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.meetingPageAnalysis_file_popup_header {\n    padding: 16px 20px;\n    border-bottom: 1px solid #E2E9FC;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.meetingPageAnalysis_file_popup_title {\n    font-size: calc(16px * var(--fontScaler));\n    font-weight: 600;\n    color: #333;\n}\n\n.meetingPageAnalysis_file_popup_close {\n    background: none;\n    border: none;\n    font-size: calc(20px * var(--fontScaler));\n    color: #999;\n    cursor: pointer;\n    padding: 0;\n    width: 28px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    transition: all 0.2s;\n}\n\n.meetingPageAnalysis_file_popup_close:hover {\n    background: #F5F5F5;\n    color: #333;\n}\n\n.meetingPageAnalysis_file_popup_body {\n    padding: 16px 20px;\n    overflow-y: auto;\n    flex: 1;\n    min-height: 0;\n}\n\n.meetingPageAnalysis_file_popup_body::-webkit-scrollbar {\n    width: 6px;\n}\n\n.meetingPageAnalysis_file_popup_body::-webkit-scrollbar-track {\n    background: #F5F5F5;\n    border-radius: 4px;\n}\n\n.meetingPageAnalysis_file_popup_body::-webkit-scrollbar-thumb {\n    background: #D5D9E2;\n    border-radius: 4px;\n}\n\n.meetingPageAnalysis_file_popup_body::-webkit-scrollbar-thumb:hover {\n    background: #B5B9C2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
